import {_} from 'underscore';


export function pluralise(text, count, params) {
    let settings = {
            addCounter: false
        },
        compiled = text;

    if (typeof params === 'object') {
        settings = _.extendOwn(settings, params);
    }


	if (count <= 0) {
		compiled = `${compiled}'s`;
	}
	else if (count > 1) {
		compiled = `${compiled}'s`;
	}
    else{
        compiled = `${compiled}`;
    }
    if (settings.addCounter) {
        if (count < 1) {
            compiled = `no ${compiled}`
        } else {
            compiled = `${count} ${compiled}`
        }
    }

    return compiled;
}

export function titleTidy(delimiter,str){
    let obj = str.split(delimiter);

    return obj.join(' ');
}
export function friendly(value) {
    return value == undefined ? '' : value.replace(/[^a-z0-9_]+/gi, '-').replace(/^-|-$/g, '').toLowerCase();
}

export function removeAllWeirdCharacters(text,includeSpaces){
    if(includeSpaces){
        return text.replace(/-|\s|_|{|}|\[|]|\(|\)|&/g, "")
    }else{
        return text.replace(/[-_{}\[\]()&]/g, "")
    }
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/strings.js